import * as React from "react";

const MOBILE_BREAKPOINT = 768;

function detectMobile() {
	let check = false;

	if (!check && typeof navigator !== "undefined" && navigator.userAgent) {
		check =
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
				navigator.userAgent,
			);
	}

	return check;
}

export function useIsMobile() {
	const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
		undefined,
	);

	React.useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

		const onChange = () => {
			setIsMobile(detectMobile());
		};

		mql.addEventListener("change", onChange);
		onChange(); // Initial check
		return () => mql.removeEventListener("change", onChange);
	}, []);

	return isMobile;
}
